function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Roda de Atalhos");

var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M29.16,48.88H15.38a32.52,32.52,0,0,0,8.93,21.57l9.74-9.75A18.78,18.78,0,0,1,29.16,48.88Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M34.05,35.3l-9.74-9.75a32.52,32.52,0,0,0-8.93,21.57H29.16A18.78,18.78,0,0,1,34.05,35.3Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M70.45,24.31a32.52,32.52,0,0,0-21.57-8.93V29.16A18.78,18.78,0,0,1,60.7,34.05Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M66.84,47.12H80.62a32.52,32.52,0,0,0-8.93-21.57L62,35.3A18.78,18.78,0,0,1,66.84,47.12Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M35.3,34.05a18.78,18.78,0,0,1,11.82-4.89V15.38a32.52,32.52,0,0,0-21.57,8.93Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M25.55,71.69a32.52,32.52,0,0,0,21.57,8.93V66.84A18.78,18.78,0,0,1,35.3,62Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M48.88,66.84V80.62a32.52,32.52,0,0,0,21.57-8.93L60.7,62A18.78,18.78,0,0,1,48.88,66.84Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M62,60.7l9.74,9.75a32.52,32.52,0,0,0,8.93-21.57H66.84A18.78,18.78,0,0,1,62,60.7Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WHEEL.c5fcff74.svg";
export { ForwardRef as ReactComponent };